let iconsObj = {}

iconsObj[ "cziAddcircle" ] = {
    prefix: 'czi',
    iconName: 'add-circle',
}
iconsObj[ "cziAdddocument" ] = {
    prefix: 'czi',
    iconName: 'add-document',
}
iconsObj[ "cziAdd-location" ] = {
    prefix: 'czi',
    iconName: 'add-location',
}
iconsObj[ "cziAdddocument" ] = {
    prefix: 'czi',
    iconName: 'add-document',
}
iconsObj[ "cziAdd" ] = {
    prefix: 'czi',
    iconName: 'add',
}
iconsObj[ "cziAnnouncement" ] = {
    prefix: 'czi',
    iconName: 'announcement',
}
iconsObj[ "cziArrowdowncircle" ] = {
    prefix: 'czi',
    iconName: 'arrow-down-circle',
}
iconsObj[ "cziArrowdown" ] = {
    prefix: 'czi',
    iconName: 'arrow-down',
}
iconsObj[ "cziArrowleftcircle" ] = {
    prefix: 'czi',
    iconName: 'arrow-left-circle',
}
iconsObj[ "cziArrowleft" ] = {
    prefix: 'czi',
    iconName: 'arrow-left',
}
iconsObj[ "cziArrowrightcircle" ] = {
    prefix: 'czi',
    iconName: 'arrow-right-circle',
}
iconsObj[ "cziArrowright" ] = {
    prefix: 'czi',
    iconName: 'arrow-right',
}
iconsObj[ "cziArrowupcircle" ] = {
    prefix: 'czi',
    iconName: 'arrow-up-circle',
}
iconsObj[ "cziArrowup" ] = {
    prefix: 'czi',
    iconName: 'arrow-up',
}
iconsObj[ "cziArrowshorizontal" ] = {
    prefix: 'czi',
    iconName: 'arrows-horizontal',
}
iconsObj[ "cziArrowsvertical" ] = {
    prefix: 'czi',
    iconName: 'arrows-vertical',
}
iconsObj[ "cziBag" ] = {
    prefix: 'czi',
    iconName: 'bag',
}
iconsObj[ "cziBasket" ] = {
    prefix: 'czi',
    iconName: 'basket',
}
iconsObj[ "cziBehance" ] = {
    prefix: 'czi',
    iconName: 'behance',
}
iconsObj[ "cziBell" ] = {
    prefix: 'czi',
    iconName: 'bell',
}
iconsObj[ "cziBluetooth" ] = {
    prefix: 'czi',
    iconName: 'bluetooth',
}
iconsObj[ "cziBook" ] = {
    prefix: 'czi',
    iconName: 'book',
}
iconsObj[ "cziBookmark" ] = {
    prefix: 'czi',
    iconName: 'bookmark',
}
iconsObj[ "cziBriefcase" ] = {
    prefix: 'czi',
    iconName: 'briefcase',
}
iconsObj[ "cziCalculator" ] = {
    prefix: 'czi',
    iconName: 'calculator',
}
iconsObj[ "cziCamera" ] = {
    prefix: 'czi',
    iconName: 'camera',
}
iconsObj[ "cziCard" ] = {
    prefix: 'czi',
    iconName: 'card',
}
iconsObj[ "cziCart" ] = {
    prefix: 'czi',
    iconName: 'cart',
}
iconsObj[ "cziChat" ] = {
    prefix: 'czi',
    iconName: 'chat',
}
iconsObj[ "cziCheckcircle" ] = {
    prefix: 'czi',
    iconName: 'check-circle',
}
iconsObj[ "cziCheck" ] = {
    prefix: 'czi',
    iconName: 'check',
}
iconsObj[ "cziClip" ] = {
    prefix: 'czi',
    iconName: 'clip',
}
iconsObj[ "cziClosecircle" ] = {
    prefix: 'czi',
    iconName: 'close-circle',
}
iconsObj[ "cziClose" ] = {
    prefix: 'czi',
    iconName: 'close',
}
iconsObj[ "cziCloudcheck" ] = {
    prefix: 'czi',
    iconName: 'cloudcheck',
}
iconsObj[ "cziClouddownload" ] = {
    prefix: 'czi',
    iconName: 'cloud-download',
}
iconsObj[ "cziCloudupload" ] = {
    prefix: 'czi',
    iconName: 'cloud-upload',
}
iconsObj[ "cziCloud" ] = {
    prefix: 'czi',
    iconName: 'cloud',
}
iconsObj[ "cziCoin" ] = {
    prefix: 'czi',
    iconName: 'coin',
}
iconsObj[ "cziCoins" ] = {
    prefix: 'czi',
    iconName: 'coins',
}
iconsObj[ "cziCurrencyexchange" ] = {
    prefix: 'czi',
    iconName: 'currency-exchange',
}
iconsObj[ "cziDeletedocument" ] = {
    prefix: 'czi',
    iconName: 'delete-document',
}
iconsObj[ "cziDeletefolder" ] = {
    prefix: 'czi',
    iconName: 'delete-folder',
}
iconsObj[ "cziDeletelocation" ] = {
    prefix: 'czi',
    iconName: 'delete-location',
}
iconsObj[ "cziDiamond" ] = {
    prefix: 'czi',
    iconName: 'diamond',
}
iconsObj[ "cziDocumentalt" ] = {
    prefix: 'czi',
    iconName: 'document-alt',
}
iconsObj[ "cziDocument" ] = {
    prefix: 'czi',
    iconName: 'document',
}
iconsObj[ "cziDollarcircle" ] = {
    prefix: 'czi',
    iconName: 'dollar-circle',
}
iconsObj[ "cziDollar" ] = {
    prefix: 'czi',
    iconName: 'dollar',
}
iconsObj[ "cziDribbble" ] = {
    prefix: 'czi',
    iconName: 'dribbble',
}
iconsObj[ "cziearphones" ] = {
    prefix: 'czi',
    iconName: 'earphones',
}
iconsObj[ "cziEditalt" ] = {
    prefix: 'czi',
    iconName: 'edit-alt',
}
iconsObj[ "cziEdit" ] = {
    prefix: 'czi',
    iconName: 'edit',
}
iconsObj[ "cziEurocircle" ] = {
    prefix: 'czi',
    iconName: 'euro-circle',
}
iconsObj[ "cziEuro" ] = {
    prefix: 'czi',
    iconName: 'euro',
}
iconsObj[ "cziExitfullscreen" ] = {
    prefix: 'czi',
    iconName: 'exit-full-screen',
}
iconsObj[ "cziEye" ] = {
    prefix: 'czi',
    iconName: 'eye',
}
iconsObj[ "cziFacebook" ] = {
    prefix: 'czi',
    iconName: 'facebook',
}
iconsObj[ "cziFilteralt" ] = {
    prefix: 'czi',
    iconName: 'filter-alt',
}
iconsObj[ "cziFilter" ] = {
    prefix: 'czi',
    iconName: 'filter',
}
iconsObj[ "cziFlag" ] = {
    prefix: 'czi',
    iconName: 'flag',
}
iconsObj[ "cziFolder" ] = {
    prefix: 'czi',
    iconName: 'folder',
}
iconsObj[ "cziForward" ] = {
    prefix: 'czi',
    iconName: 'forward',
}
iconsObj[ "cziFullscreen" ] = {
    prefix: 'czi',
    iconName: 'full-screen',
}
iconsObj[ "cziGift" ] = {
    prefix: 'czi',
    iconName: 'gift',
}
iconsObj[ "cziGlobe" ] = {
    prefix: 'czi',
    iconName: 'globe',
}
iconsObj[ "cziGoogle" ] = {
    prefix: 'czi',
    iconName: 'google',
}
iconsObj[ "cziHangouts" ] = {
    prefix: 'czi',
    iconName: 'hangouts',
}
iconsObj[ "cziHeartcircle" ] = {
    prefix: 'czi',
    iconName: 'heart-circle',
}
iconsObj[ "cziHeart" ] = {
    prefix: 'czi',
    iconName: 'heart',
}
iconsObj[ "cziHelp" ] = {
    prefix: 'czi',
    iconName: 'help',
}
iconsObj[ "cziHome" ] = {
    prefix: 'czi',
    iconName: 'home',
}
iconsObj[ "cziIdea" ] = {
    prefix: 'czi',
    iconName: 'idea',
}
iconsObj[ "cziImage" ] = {
    prefix: 'czi',
    iconName: 'image',
}
iconsObj[ "cziIncrease" ] = {
    prefix: 'czi',
    iconName: 'increase',
}
iconsObj[ "cziInstagram" ] = {
    prefix: 'czi',
    iconName: 'instagram',
}
iconsObj[ "cziJoystick" ] = {
    prefix: 'czi',
    iconName: 'joystick',
}
iconsObj[ "cziKey" ] = {
    prefix: 'czi',
    iconName: 'key',
}
iconsObj[ "cziLable" ] = {
    prefix: 'czi',
    iconName: 'lable',
}
iconsObj[ "cziLaptop" ] = {
    prefix: 'czi',
    iconName: 'laptop',
}
iconsObj[ "cziLightning" ] = {
    prefix: 'czi',
    iconName: 'lightning',
}
iconsObj[ "cziLink" ] = {
    prefix: 'czi',
    iconName: 'link',
}
iconsObj[ "cziLinkedin" ] = {
    prefix: 'czi',
    iconName: 'linkedin',
}
iconsObj[ "cziList" ] = {
    prefix: 'czi',
    iconName: 'list',
}
iconsObj[ "cziLoading" ] = {
    prefix: 'czi',
    iconName: 'loading',
}
iconsObj[ "cziLocation" ] = {
    prefix: 'czi',
    iconName: 'location',
}
iconsObj[ "cziLocked" ] = {
    prefix: 'czi',
    iconName: 'locked',
}
iconsObj[ "cziMail" ] = {
    prefix: 'czi',
    iconName: 'mail',
}
iconsObj[ "cziMap" ] = {
    prefix: 'czi',
    iconName: 'map',
}
iconsObj[ "cziMenucircle" ] = {
    prefix: 'czi',
    iconName: 'menu-circle',
}
iconsObj[ "cziMenu" ] = {
    prefix: 'czi',
    iconName: 'menu',
}
iconsObj[ "cziMessage" ] = {
    prefix: 'czi',
    iconName: 'message',
}
iconsObj[ "cziMessenger" ] = {
    prefix: 'czi',
    iconName: 'messenger',
}
iconsObj[ "cziMobile" ] = {
    prefix: 'czi',
    iconName: 'mobile',
}
iconsObj[ "cziMoneybag" ] = {
    prefix: 'czi',
    iconName: 'money-bag',
}
iconsObj[ "cziMoneybox" ] = {
    prefix: 'czi',
    iconName: 'money-box',
}
iconsObj[ "cziMoon" ] = {
    prefix: 'czi',
    iconName: 'moon',
}
iconsObj[ "cziMusic" ] = {
    prefix: 'czi',
    iconName: 'music',
}
iconsObj[ "cziNavigation" ] = {
    prefix: 'czi',
    iconName: 'navigation',
}
iconsObj[ "cziOdnoklassniki" ] = {
    prefix: 'czi',
    iconName: 'odnoklassniki',
}
iconsObj[ "cziPackage" ] = {
    prefix: 'czi',
    iconName: 'package',
}
iconsObj[ "cziPercent" ] = {
    prefix: 'czi',
    iconName: 'percent',
}
iconsObj[ "cziPhone" ] = {
    prefix: 'czi',
    iconName: 'phone',
}
iconsObj[ "cziPinterest" ] = {
    prefix: 'czi',
    iconName: 'pinterest',
}
iconsObj[ "cziPlane" ] = {
    prefix: 'czi',
    iconName: 'plane',
}
iconsObj[ "cziPlaycircle" ] = {
    prefix: 'czi',
    iconName: 'play-circle',
}
iconsObj[ "cziPlay" ] = {
    prefix: 'czi',
    iconName: 'play',
}
iconsObj[ "cziReduce" ] = {
    prefix: 'czi',
    iconName: 'reduce',
}
iconsObj[ "cziReload" ] = {
    prefix: 'czi',
    iconName: 'reload',
}
iconsObj[ "cziRemovedocument" ] = {
    prefix: 'czi',
    iconName: 'remove-document',
}
iconsObj[ "cziRemovefolder" ] = {
    prefix: 'czi',
    iconName: 'remove-folder',
}
iconsObj[ "cziReply" ] = {
    prefix: 'czi',
    iconName: 'reply',
}
iconsObj[ "cziRocket" ] = {
    prefix: 'czi',
    iconName: 'rocket',
}
iconsObj[ "cziRuler" ] = {
    prefix: 'czi',
    iconName: 'ruler',
}
iconsObj[ "cziScroll" ] = {
    prefix: 'czi',
    iconName: 'scroll',
}
iconsObj[ "cziSearch" ] = {
    prefix: 'czi',
    iconName: 'search',
}
iconsObj[ "cziSecurityannouncement" ] = {
    prefix: 'czi',
    iconName: 'security-announcement',
}
iconsObj[ "cziSecuritycheck" ] = {
    prefix: 'czi',
    iconName: 'security-check',
}
iconsObj[ "cziSecurity" ] = {
    prefix: 'czi',
    iconName: 'security',
}
iconsObj[ "cziSecurityprohibition" ] = {
    prefix: 'czi',
    iconName: 'security-prohibition',
}
iconsObj[ "cziSend" ] = {
    prefix: 'czi',
    iconName: 'send',
}
iconsObj[ "cziServeralt" ] = {
    prefix: 'czi',
    iconName: 'server-alt',
}
iconsObj[ "cziServer" ] = {
    prefix: 'czi',
    iconName: 'server',
}
iconsObj[ "cziSettings" ] = {
    prefix: 'czi',
    iconName: 'settings',
}
iconsObj[ "cziSharealt" ] = {
    prefix: 'czi',
    iconName: 'share-alt',
}
iconsObj[ "cziShare" ] = {
    prefix: 'czi',
    iconName: 'share',
}
iconsObj[ "cziSkype" ] = {
    prefix: 'czi',
    iconName: 'skype',
}
iconsObj[ "cziSmile" ] = {
    prefix: 'czi',
    iconName: 'smile',
}
iconsObj[ "cziStarfilled" ] = {
    prefix: 'czi',
    iconName: 'star-filled',
}
iconsObj[ "cziStar" ] = {
    prefix: 'czi',
    iconName: 'star',
}
iconsObj[ "cziSun" ] = {
    prefix: 'czi',
    iconName: 'sun',
}
iconsObj[ "cziSupport" ] = {
    prefix: 'czi',
    iconName: 'support',
}
iconsObj[ "cziTarget" ] = {
    prefix: 'czi',
    iconName: 'target',
}
iconsObj[ "cziTelegram" ] = {
    prefix: 'czi',
    iconName: 'telegram',
}
iconsObj[ "cziThumbup" ] = {
    prefix: 'czi',
    iconName: 'thumb-up',
}
iconsObj[ "cziTime" ] = {
    prefix: 'czi',
    iconName: 'time',
}
iconsObj[ "cziTrash" ] = {
    prefix: 'czi',
    iconName: 'trash',
}
iconsObj[ "cziTumblr" ] = {
    prefix: 'czi',
    iconName: 'tumblr',
}
iconsObj[ "cziTurnoff" ] = {
    prefix: 'czi',
    iconName: 'turn-off',
}
iconsObj[ "cziTwitter" ] = {
    prefix: 'czi',
    iconName: 'twitter',
}
iconsObj[ "cziUnlocked" ] = {
    prefix: 'czi',
    iconName: 'unlocked',
}
iconsObj[ "cziUsercircle" ] = {
    prefix: 'czi',
    iconName: 'user-circle',
}
iconsObj[ "cziUser" ] = {
    prefix: 'czi',
    iconName: 'user',
}
iconsObj[ "cziViber" ] = {
    prefix: 'czi',
    iconName: 'viber',
}
iconsObj[ "cziVideo" ] = {
    prefix: 'czi',
    iconName: 'video',
}
iconsObj[ "cziViewgrid" ] = {
    prefix: 'czi',
    iconName: 'view-grid',
}
iconsObj[ "cziViewlist" ] = {
    prefix: 'czi',
    iconName: 'view-list',
}
iconsObj[ "cziVimeo" ] = {
    prefix: 'czi',
    iconName: 'vimeo',
}
iconsObj[ "cziVk" ] = {
    prefix: 'czi',
    iconName: 'vk',
}
iconsObj[ "cziWallet" ] = {
    prefix: 'czi',
    iconName: 'wallet',
}
iconsObj[ "cziWatch" ] = {
    prefix: 'czi',
    iconName: 'watch',
}
iconsObj[ "cziWeather" ] = {
    prefix: 'czi',
    iconName: 'weather',
}
iconsObj[ "cziWechat" ] = {
    prefix: 'czi',
    iconName: 'wechat',
}
iconsObj[ "cziYoutubeoutline" ] = {
    prefix: 'czi',
    iconName: 'youtube-outline',
}
iconsObj[ "cziYoutube" ] = {
    prefix: 'czi',
    iconName: 'youtube',
}
iconsObj[ "cziCaret" ] = {
    prefix: 'czi',
    iconName: 'caret',
}
iconsObj[ "cziPaypal" ] = {
    prefix: 'czi',
    iconName: 'paypal',
}
iconsObj[ "cziDelivery" ] = {
    prefix: 'czi',
    iconName: 'delivery',
}
iconsObj[ "cziLoudspeaker" ] = {
    prefix: 'czi',
    iconName: 'loudspeaker',
}
iconsObj[ "cziSignin" ] = {
    prefix: 'czi',
    iconName: 'sign-in',
}
iconsObj[ "cziSignout" ] = {
    prefix: 'czi',
    iconName: 'sign-out',
}
iconsObj[ "cziWash" ] = {
    prefix: 'czi',
    iconName: 'wash',
}
iconsObj[ "cziBleach" ] = {
    prefix: 'czi',
    iconName: 'bleach',
}
iconsObj[ "cziHandwash" ] = {
    prefix: 'czi',
    iconName: 'hand-wash',
}
iconsObj[ "cziIroning" ] = {
    prefix: 'czi',
    iconName: 'ironing',
}
iconsObj[ "cziDryclean" ] = {
    prefix: 'czi',
    iconName: 'dry-clean',
}
iconsObj[ "cziAdduser" ] = {
    prefix: 'czi',
    iconName: 'add-user',
}
iconsObj[ "cziCompare" ] = {
    prefix: 'czi',
    iconName: 'compare',
}
iconsObj[ "cziMonitor" ] = {
    prefix: 'czi',
    iconName: 'monitor',
}
iconsObj[ "cziPrinter" ] = {
    prefix: 'czi',
    iconName: 'printer',
}
iconsObj[ "cziSpeaker" ] = {
    prefix: 'czi',
    iconName: 'speaker',
}
iconsObj[ "cziDownload" ] = {
    prefix: 'czi',
    iconName: 'download',
}
iconsObj[ "cziUpload" ] = {
    prefix: 'czi',
    iconName: 'upload',
}


export const czi = iconsObj